import React, { ComponentType } from 'react';
import styled from '@emotion/styled';
import { Flex } from 'reflexbox';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container = styled(Flex)`
  flex-direction: column;
  flex-grow: 1;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

export const Filters: ComponentType = (props) => {
  const { children } = props;
  return <Container>{children}</Container>;
};
